/* eslint-disable func-names */
// eslint-disable-next-line no-undef
const $ = jQuery;

function closeMenu() {
  //  Close menu and all open elements within
  $('.workforce-menu__landing-page-container--active').removeClass(
    'workforce-menu__landing-page-container--active',
  );
  $('.workforce-menu__ul--active').removeClass('workforce-menu__ul--active');
  $('.workforce-menu__a--active').removeClass('workforce-menu__a--active');
  $('.workforce-menu').removeClass('mobile-active');
  $('#main-nav-burger').removeClass('main-nav-burger--open');
  $('body').removeClass('no-scroll');
}

function closeSiteSection($container) {
  //  Close a site section and all open elements within
  $container.removeClass('workforce-menu__ul--active');
  $container
    .find('.workforce-menu__ul--active')
    .removeClass('workforce-menu__ul--active');
  $container
    .find('.workforce-menu__a--active')
    .removeClass('workforce-menu__a--active');
  $container
    .find('.workforce-menu__landing-page-container--active')
    .removeClass('workforce-menu__landing-page-container--active');
  $(`[data-target="${$container.attr('id')}"]`).removeClass(
    'workforce-menu__a--active',
  );
}

function closeLandingPage($container) {
  //  Close a landing page section
  $(
    '.workforce-menu__ul--section-content-page.workforce-menu__ul--active',
  ).removeClass('workforce-menu__ul--active');
  $container.removeClass('workforce-menu__landing-page-container--active');
  document.activeElement.blur();
  $('body').removeClass('no-scroll');
}

function toggleMoreMenu(openMe = true) {
  //  Close the more menu
  if (openMe) {
    $('.more-menu__ul--pages').addClass('more-menu__ul--active');
  } else {
    $('.more-menu__ul--pages').removeClass('more-menu__ul--active');
  }
}

function triggerLandingPage(node, type)
{
  // Open the selected landing page
  node.addClass(
    'workforce-menu__landing-page-container--active',
  );
  node
    .parent()
    .find('.workforce-menu__ul--section-content-page')
    .addClass('workforce-menu__ul--active');
  $('body').addClass('no-scroll');
}

export function initMenuMain() {
  //  Open/close site section in menu
  $('.workforce-menu__a[data-target]').click(function () {
    //  Get target element
    const $target = $(`#${$(this).attr('data-target')}`);
    if ($target.hasClass('workforce-menu__ul--active')) {

      //  If clicking the already open site section
      //  Desktop - close the whole menu
      //  Mobile, collapse the site section and any expanded elements within
      if ($(window).width() > 1072) {
        closeMenu();
      } else {
        closeSiteSection($target);
      }
    } else {
      //  If clicking a currently unopened site section
      //  Close the open site section
      closeSiteSection(
        $(
          '.workforce-menu__ul--section-content-container.workforce-menu__ul--active',
        ),
      );
      //  Show menu content and set site section link to active
      $target.addClass('workforce-menu__ul--active');
      $(this).addClass('workforce-menu__a--active');
      $('body').addClass('no-scroll');

      if ($(window).width() > 1072) {
        //  If desktop, have the first Landing Page selected when opening the Site Section overlay
        const $firstLandingPageContainer = $target
          .find('.workforce-menu__li--landing-page')
          .eq(0);
        $firstLandingPageContainer
          .find('.workforce-menu__landing-page-container')
          .addClass('workforce-menu__landing-page-container--active');
        $firstLandingPageContainer
          .find('.workforce-menu__ul--section-content-page')
          .addClass('workforce-menu__ul--active');
      }
    }
  });

  //  Open/close the mobile menu
  $('#main-nav-burger').click(function () {
    if ($(this).hasClass('main-nav-burger--open')) {
      //  Close the mobile menu
      closeMenu();
    } else {
      //  Open the mobile menu
      $('.workforce-menu').addClass('mobile-active');
      $('#main-nav-burger').addClass('main-nav-burger--open');
      $('body').addClass('no-scroll');
    }
  });

  $('.workforce-menu__a--close-overlay').click(() => {
    //  Close the desktop overlay
    closeMenu();
  });

   //  Open/close Landing Page accordion elements in mega menu - desktop
  $('.workforce-menu--desktop-only').not('.workforce-menu__li--close-overlay').click(function () {
    let $landingPageContainer = $(this).closest(
      '.workforce-menu__landing-page-container',
    );
    closeLandingPage($('.workforce-menu__landing-page-container--active'));
    triggerLandingPage($landingPageContainer);
  });

  $('.workforce-menu--mobile-only').click(function () {
    let $landingPageContainer = $(this).closest(
      '.workforce-menu__landing-page-container',
    );

    if($landingPageContainer[0]
        .classList
        .contains('workforce-menu__landing-page-container--active')
      ) {
      //  Close the currently open landing page
      closeLandingPage($('.workforce-menu__landing-page-container--active'));
      return;
    }
    triggerLandingPage($landingPageContainer);
  });

  //  Open/close more-menu
  $('.more-menu__a--top-level').click((e) => {
    e.preventDefault();
    if ($('.more-menu__ul--pages').hasClass('more-menu__ul--active')) {
      toggleMoreMenu(false);
    } else {
      toggleMoreMenu(true);
    }
  });

  $(document).keyup(function(e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
      if($('.workforce-menu__ul--section-content-container').is(':visible')) {
        closeMenu();
      }
    }
  });

  //  Close more-menu when clicking outside of it
  $(document).click((event) => {
    const $target = $(event.target);
    if (
      !$target.closest('.more-menu__a--top-level').length
      && $('.more-menu__a--top-level').is(':visible')
    ) {
      toggleMoreMenu(false);
    }
  });
}
export default 'initMenuMain';
